import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  returnUrl: string = '/';
  loading: boolean = false;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Get return URL from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    // Check if user is already authenticated
    this.auth.isAuthenticated().subscribe(
      isAuthenticated => {
        if (isAuthenticated) {
          this.router.navigate([this.returnUrl]);
        } else {
          // Auto-login if this is the login page
          this.login();
        }
      }
    );
  }

  login(): void {
    this.loading = true;
    this.auth.login();
  }
}
